import Stack from '@mui/material/Stack'

import { Drawer, useGlobalCopyStore } from '../../common'
import { useDebtsUiStore } from '../hooks/useDebtsUiStore'

import AccountDetailsHeader from '../../accounts/components/detailsdrawer/Accounts/AccountDetailsHeader'
import DebtDetailsChart from './debtsdrawer/DebtDetailsChart'
import DebtDetailsContent from './debtsdrawer/DebtDetailsContent'

interface DebtDrawerProps {
  isOpen: boolean
  onClose: () => void
}

const DebtDrawer = ({ isOpen, onClose }: DebtDrawerProps) => {
  const { debts: copy } = useGlobalCopyStore()
  const { showError, showCompleted } = useDebtsUiStore()
  const headerChart = showError || showCompleted ? <></> : <DebtDetailsChart />

  return (
    <Drawer
      ariaLabelClose={copy.details_close_aria}
      isOpen={isOpen}
      onClose={onClose}
      title={copy.details_title}
    >
      <Stack bgcolor="background.default">
        <AccountDetailsHeader customDetailsChart={headerChart} />
        <DebtDetailsContent />
      </Stack>
    </Drawer>
  )
}

export default DebtDrawer
